import { useState } from 'react';
import axios from 'axios';

const usePostRequest = () => {
    const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const post = async (endpoint, payload, config = {}) => {
        setLoading(true);
        setError(null);
        const token = sessionStorage.getItem('authToken');

        const finalConfig = {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...(config.headers || {}),
            }
        };
        try {
            const response = await axios.post(baseURL + endpoint, payload, finalConfig);
            setData(response.data);
            return response.data;
        } catch (err) {
            setError(err.response?.data || err.message);
            return err.response?.data;
        } finally {
            setLoading(false);
        }
    };

    return { post, data, loading, error };
};

export default usePostRequest;
